import DeviceMobileIcon from '@atlaskit/icon/core/device-mobile';
import * as React from 'react';

export const SvgMobileDevices = () => {
  return <DeviceMobileIcon label="" testId="ads-refreshed-icon" />;
};
